export default __webpack_public_path__ + "static/media/favorite_filled.10a0b755.svg";